import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/ui/Input/Input.jsx';
import Textarea from '../../components/ui/Textarea/Textarea.jsx';
import Button from '../../components/ui/Button/Button.jsx';
import Badge from '../../components/ui/Badge/Badge.jsx';
import { submitContactForm } from '../../services/contactService.js';
import styles from './Contact.module.css';

const initialState = { name: '', email: '', company: '', budget: '', message: '' };

export default function Contact() {
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const navigate = useNavigate();

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  function validate() {
    const next = {};
    if (!form.name.trim()) next.name = 'Enter your name.';
    if (!form.email.trim()) next.email = 'Enter your email.';
    else if (!/^\S+@\S+\.\S+$/.test(form.email)) next.email = 'Enter a valid email.';
    if (!form.message.trim()) next.message = 'Tell us a bit about your project.';
    setErrors(next);
    return Object.keys(next).length === 0;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitError('');
    if (!validate()) return;
    setSubmitting(true);
    try {
      await submitContactForm(form);
      navigate('/success');
    } catch (err) {
      setSubmitError('Something went wrong sending your message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section className={styles.section}>
      <div className={`container ${styles.grid}`}>
        <div className={styles.info}>
          <Badge tone="secondary">Get in touch</Badge>
          <h1 className={styles.title}>Tell us about your launch</h1>
          <p className={styles.lead}>
            Whether you're evaluating Solvora for a client project or your own product,
            we'll get back to you within one business day.
          </p>

          <div className={styles.details}>
            <div className={styles.detail}>
              <span className={styles.detailLabel}>Email</span>
              <span className={styles.detailValue}>hello@solvora.app</span>
            </div>
            <div className={styles.detail}>
              <span className={styles.detailLabel}>Based in</span>
              <span className={styles.detailValue}>Remote-first, worldwide</span>
            </div>
            <div className={styles.detail}>
              <span className={styles.detailLabel}>Response time</span>
              <span className={styles.detailValue}>Within 1 business day</span>
            </div>
          </div>
        </div>

        <form className={styles.form} onSubmit={handleSubmit} noValidate>
          <div className={styles.row}>
            <Input id="name" label="Name" placeholder="Jordan Lee" value={form.name} onChange={update('name')} error={errors.name} />
            <Input id="email" type="email" label="Email" placeholder="you@company.com" value={form.email} onChange={update('email')} error={errors.email} />
          </div>
          <div className={styles.row}>
            <Input id="company" label="Company (optional)" placeholder="Acme Inc." value={form.company} onChange={update('company')} />
            <Input id="budget" label="Budget range (optional)" placeholder="$5k–$15k" value={form.budget} onChange={update('budget')} />
          </div>
          <Textarea id="message" label="What are you launching?" placeholder="Tell us about your product and timeline." value={form.message} onChange={update('message')} error={errors.message} />

          {submitError && <p className={styles.formError}>{submitError}</p>}

          <Button type="submit" size="lg" disabled={submitting}>
            {submitting ? 'Sending…' : 'Send message'}
          </Button>
        </form>
      </div>
    </section>
  );
}
